import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { CustomServiceService } from '../../service/custom-service.service';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-seeyourdepotnew',
  templateUrl: './seeyourdepotnew.component.html',
  styleUrls: ['./seeyourdepotnew.component.css']
})
export class SeeyourdepotnewComponent implements OnInit {


  constructor(private fciwebservice: fciWebsiteService, private httpservice: CustomServiceService, private routerparam: ActivatedRoute, private encDec: EncryptDecryptService, private route: Router, public translate: TranslateService) { }
  language:any = sessionStorage.getItem('locale');//dynamic
  btncontent: any = this.language=='English'?`Search`:`खोज`;
  backend_url: any = environment.serviceURL;
 
  start: number = 0;
  limit: number = 10;
  currentPage: number = 1;
  totalRecords: number = 0;
 

  plugin_menu_dtl: any;
  employee_con: any = "";
  showEmpMen: boolean = false;
  showNavComponent: boolean = false;
  showBarComponent: boolean = false;
  isdisplay: boolean = false;
  issearch: boolean = false;
  CurrentRouteFn: any = (): any => {
    let route_url: any = this.route.url.replace('/', "");
    route_url = route_url.split("?");
    if (route_url.length > 0) {
      return route_url[0];
    }
    return route_url;
  }
 
  CURRENT_ZONE_ID: any = environment.ZONE_ID;
  CURRENT_REGION_ID: any = environment.REGION_ID;
  CURRENT_ZONE_CODE: any = environment.ZONE_CODE;
  CURRENT_REGION_CODE: any = environment.REGION_CODE;
  datetime: any = this.httpservice.currentDateTime();
  ngOnInit(): void {

    document.title = "See Your Depot";
    this.start = (this.currentPage - 1) * this.limit;
    this.language = sessionStorage.getItem('locale');//dynamic
    this.btncontent=(this.language=='English') ? 'Search' : 'खोजें';
    // if(environment.ZONE_ID > 0){
    //   this.tenderlist('','','','',environment.ZONE_ID,'',this.start,this.limit,this.currentPage);
    //     this.GetAllZoneById(environment.ZONE_ID);
    //     this.GetRegion(environment.ZONE_ID);
    //  } else {
    //   this.tenderlist('','','','','','',this.start,this.limit,this.currentPage);
    //   this.TenderZoneList();
    //  }
    this.depotlist('', '', '', this.start, this.limit, this.currentPage);
    this.Alldepotlist('', '', '', 0, 0,0);
    this.TenderZoneList();
    this.employee_con = this.routerparam.snapshot.queryParamMap.get('emp');
    if (this.employee_con == null) {
      this.plugin_menu_dtl = window.sessionStorage.getItem(btoa(this.CurrentRouteFn()));
      this.getPluginPageDetials(this.plugin_menu_dtl);
    } else {
      this.getEmployeeCornerDtl(this.encDec.decText(this.employee_con));
    }
   
  }

  ngAfterViewInit(): void {
    //FOR SCROLLING TO TOP WHEN COMPONENT LOADS
    // $('html, body').scrollTop(0);
  }
  searchForm = new FormGroup({
    depot: new FormControl(''),
    zone: new FormControl(''),
    region: new FormControl('')
  })

  get depot() {
    return this.searchForm.get('depot');
  }
  get zone() {
    return this.searchForm.get('zone');
  }
  get region() {
    return this.searchForm.get('region');
  }
  RefreshBtn: boolean = false;
  RefreshPage() {
    this.start = 0;
    this.limit = 10;
    this.currentPage = 1;
    this.totalRecords = 0;
    this.depotlist('', '', '', this.start, this.limit, this.currentPage);
    this.RefreshBtn = false;
    this.searchForm.reset();
    $('select#zone').prop('selectedIndex', 0);
    $('select#region').prop('selectedIndex', 0);
    $('select#depot').prop('selectedIndex', 0);
    this.depotListIs = [];
    this.regionList = [];
  }
  depotModel_:any='';
  depotModel(e:any){
    this.searchForm.patchValue({depot:e}); //FOR BINDING DEPOT DATA
  }
  searchTender() {
    let param_arr = [];
    this.isdisplay = true;
    let depot, zone, region;
    depot = "";
    zone = "";
    region = "";

    if (this.searchForm.value.depot !== "") {
      if (this.searchForm.value.depot !== null) {
        param_arr.push(this.searchForm.value.depot);
        depot = this.searchForm.value.depot;
      }
    }
    if (this.searchForm.value.zone !== "") {
      if (this.searchForm.value.zone !== null) {
        param_arr.push(this.searchForm.value.zone);
        zone = this.searchForm.value.zone;
      }
    }
    if (this.searchForm.value.region !== "") {
      if (this.searchForm.value.region !== null) {
        param_arr.push(this.searchForm.value.region);
        region = this.searchForm.value.region;
      }
    }
    if (param_arr.length <= 0) {
      if(this.language=='English'){
        alert('Please select at least one parameter');
      }else{
        alert('कृपया कम से कम एक पैरामीटर चुनें');  
      }
      return;
    }
    this.RefreshBtn = true;
    this.start = 0;
    this.limit = 10;
    this.currentPage = 1;
    this.totalRecords = 0;
    this.depotlist(depot, zone, region, this.start, this.limit, this.currentPage);
  }


  zone_apirespons: any;
  zoneList: any[] = [];
  TenderZoneList() {
    this.httpservice.getZoneList().subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.zone_apirespons = response.body;
          let respData = this.zone_apirespons.RESPONSE_DATA;
          let respToken = this.zone_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
            this.zoneList = res.original.data;
          }
      }
    });
  }


  GetAllZoneById(zoneid: any) {
    this.zoneList = [];
    this.regionList = [];
    this.httpservice.GetAllZoneById({ 'zone_id': zoneid }).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.zone_apirespons = response.body;
          let respData = this.zone_apirespons.RESPONSE_DATA;
          let respToken = this.zone_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
            this.zoneList = res.original.list;
          }
      }
    });
  }


  depotListIs: any[] = [];
  depotListIsForSelect: any[] = [];
  GetDepotList(regioncode: any) {
    this.searchForm.patchValue({ depot: '' });
    this.depotListIs = [];
    let params = { regioncode };
    this.httpservice.getdepotlistData(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.region_apirespons = response.body;
          let respData = this.region_apirespons.RESPONSE_DATA;
          let respToken = this.region_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
            this.depotListIs = res.original.data;
            let listIs = res.original.data;
            // console.log(listIs);
            listIs.forEach((element:any) => {
              if(this.language=='English'){
                this.depotListIsForSelect.push({id:element.DEPOT_CODE,name:element.DEPOT_NAME}); //FOR GETTING THE DEPOT DATA
              }
              else if(this.language=='Hindi'){

                if(this.AllData.length>0){
                  this.AllData.forEach((e:any) => {                       
                    if(e.depot==element.DEPOT_CODE){    
                       this.depotListIsForSelect.push({id:element.DEPOT_CODE,name:e.depotHindiName}); //FOR GETTING THE DEPOT DATA

                    }
                  });
                }                
              }           

            });

          //  console.log(this.depotListIsForSelect);
           
          }
      }
    });
  }



  region_apirespons: any;
  regionList: any[] = [];
  GetRegion(val: any) {
    this.searchForm.patchValue({ region: '', depot: '' });
    this.depotListIs = [];
    this.regionList = [];
    let p = { 'zone_id': val };
    if (val == "") {
      return;
    }
    this.httpservice.GetRegionByZoneId(p).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.region_apirespons = response.body;
          let respData = this.region_apirespons.RESPONSE_DATA;
          let respToken = this.region_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
            this.regionList = res.original.data;
          }
      }
    });
  }







  pageChanged(page: any) {
    let param_arr = [];
    let depot, zone, region;
    depot = "";
    zone = "";
    region = "";

    if (this.searchForm.value.depot !== "") {
      if (this.searchForm.value.depot !== null) {
        param_arr.push(this.searchForm.value.depot);
        depot = this.searchForm.value.depot;
      }
    }
    if (this.searchForm.value.zone !== "") {
      if (this.searchForm.value.zone !== null) {
        param_arr.push(this.searchForm.value.zone);
        zone = this.searchForm.value.zone;
      }
    }
    if (this.searchForm.value.region !== "") {
      if (this.searchForm.value.region !== null) {
        param_arr.push(this.searchForm.value.region);
        region = this.searchForm.value.region;
      }
    }

    this.currentPage = page;
    this.start = (this.currentPage - 1) * this.limit;
    this.depotlist(depot, zone, region, this.start, this.limit, this.currentPage);
  }
  ifdisabled: boolean = false;
  apirespons: any;
  depotListData: any[] = [];
  Ltype: any;
  AllData:any=[];
  Alldepotlist(depot: any, zone: any, region: any, start: number, limit: number, currentPage: number) {
    this.ifdisabled = true;
    this.btncontent = `<i class="spinner-border spinner-size" aria-hidden="true"></i>`;
    var query: any = [];


    query = [
      { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
      { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
    ];

   

    let params = [

      {
        "secSlNo": 1,
        "offSet": start,
        "noOfRecords": limit,
        "orderBy": [{ "columnName": "intId", "type": "DESC" }],
        "condition": query,
        "viewParameters": ""
      }];
    this.httpservice.getManageDepotDetails(params).subscribe((response: HttpEvent<any>) => {

      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:

          this.apirespons = response.body;
          let respData = this.apirespons.RESPONSE_DATA;
          let respToken = this.apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            this.AllData = response.result.sec_1;  
            
            //console.log(this.AllData);

          }
          this.ifdisabled = false;
          this.btncontent = this.language=='English'?`Search`:`खोज`;


      }
    });
  }

  depotlist(depot: any, zone: any, region: any, start: number, limit: number, currentPage: number) {
    this.ifdisabled = true;
    this.btncontent = `<i class="spinner-border spinner-size" aria-hidden="true"></i>`;
    var query: any = [];


    query = [
      { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
      { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
    ];

    if (depot !== "") {
      if (depot !== null) {
        query.push({ "columnName": "VCH_DEPOT_CODE", "operator": "=", "value": depot, "joinoperator": "and" });
      }
    }
    if (zone !== "") {
      if (zone !== null) {
        query.push({ "columnName": "INT_ZONE_ID", "operator": "=", "value": zone, "joinoperator": "and" });
      }
    }
    if (region !== "") {
      if (region !== null) {
        query.push({ "columnName": "VCH_REGION_CODE", "operator": "=", "value": region, "joinoperator": "and" });
      }
    }

    let params = [

      {
        "secSlNo": 1,
        "offSet": start,
        "noOfRecords": limit,
        "orderBy": [{ "columnName": "intId", "type": "DESC" }],
        "condition": query,
        "viewParameters": ""
      }];
    this.httpservice.getManageDepotDetails(params).subscribe((response: HttpEvent<any>) => {

      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:

          this.apirespons = response.body;
          let respData = this.apirespons.RESPONSE_DATA;
          let respToken = this.apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            this.depotListData = response.result.sec_1;
            //  console.log(this.depotListData);
            if (response.result.sec_1.length > 0) {
              this.totalRecords = response.result.sec_1[0].noOfRec;
              this.issearch = true;
            } else {
              this.totalRecords = 0;
              this.issearch = false;
            }

          }
          this.ifdisabled = false;
          this.btncontent = this.language=='English'?`Search`:`खोज`;


      }
    });
  }



  jsonConvert(data: any, type: any) {
     
    if (data == "" || data == null) {
      return "";
    }
    if (data.jsonOptTxtDetails == "" || data.jsonOptTxtDetails == null) {
      return "";
    }
    let d = JSON.parse(data.jsonOptTxtDetails);
    if (type == 'INT_ZONE_ID') {
      let zone='';
      //return d.INT_ZONE_ID;
      this.zoneList.forEach(e => {
         if(e.int_Demographic_Id==data.zone) {
           zone= (this.language=='English') ? e.vch_Demographic_Name : e.vch_Demographic_Name_Hindi;
         } 
      });

      return zone;
     
    } else if (type == 'VCH_REGION_CODE') {
      //return d.VCH_REGION_CODE;
      
      let region='';
      let alldata:any = this.fciwebservice.ZoneRegionNameData();   
      alldata.data.forEach((e:any) => {
        if(e.zone.int_Demographic_Id==data.zone) {
          e.region.forEach((res:any) => {
            if(res.vch_Code==data.region) {
              region= (this.language=='English') ? res.vch_Demographic_Name : res.vch_Demographic_Name_Hindi;
            }
          })          
        } 
     });
     return region;
    } else if (type == 'VCH_DEPOT_CODE') {
      return (this.language=='English') ? d.VCH_DEPOT_CODE : data.depotHindiName;
    } else {
      return '';
    }
  }

  getDepotName(depot:any){
   
    let res='';
    
        if(this.language=='English'){
          res= depot;
        }
        else{
    
          if(this.AllData.length>0){
            this.AllData.forEach((e:any) => {     
              let d = JSON.parse(e.jsonOptTxtDetails);          
              if(depot==d.VCH_DEPOT_CODE){
                 res=  e.depotHindiName;
              }
            });
          }
          
        } 

        return  res;
    
      }

  htmlTag(data: any) {
    return this.encDec.decodeHtml(data);
  }

  encode(data: any) {
    return btoa(data);
  }



  encriptdata(id: any) {
    return this.encDec.encText(id.toString());
  }



  viewDetails(id: any, pageName: any) {
    let encSchemeStr = this.encDec.encText(id.toString());
    this.route.navigate(['/' + pageName + '/', encSchemeStr]);
  }






  emp_apires: any;
  emp_dtl: any = { 'title': '' };
  getEmployeeCornerDtl(id: any) {
    let params = [
      {
        "secSlNo": 1,
        "offSet": 0,
        "noOfRecords": 0,
        "orderBy": [],
        "condition": [
          { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
          { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
          { "columnName": "intId", "operator": "=", "value": id, "joinoperator": "and" },
        ],
        "viewParameters": ""
      }];
    this.httpservice.EmpeeloyCorner(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.emp_apires = response.body;
          let respData = this.emp_apires.RESPONSE_DATA;
          let respToken = this.emp_apires.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response_: any = Buffer.from(respData, 'base64');
            response_ = JSON.parse(response_);
            if (response_.result.sec_1.length > 0) {
              this.emp_dtl = response_.result.sec_1[0];
              this.showBarComponent = true;
              this.showEmpMen = true;
            }
          }
      }
    });
  }

  navmenuloadCss = "background-color: #167a44; height: 100%;";
  p_apirespons: any;
  P_data: any;

  navMenu: boolean = false;
  getPluginPageDetials(details: any) {
    let params;
    if (details !== null) {
      let d = JSON.parse(details);
      params = {
        "zone_id": environment.ZONE_ID,
        "zone_code": environment.ZONE_CODE,
        "region_id": environment.REGION_ID,
        "region_code": environment.REGION_CODE,
        "plugin_id": d.plugin_id,
        'router_link': d.selectPlugin,
        'localdata': true,
      };
    } else {
      params = {
        "zone_id": environment.ZONE_ID,
        "zone_code": environment.ZONE_CODE,
        "region_id": environment.REGION_ID,
        "region_code": environment.REGION_CODE,
        "plugin_id": false,
        'router_link': this.CurrentRouteFn(),
        'localdata': false,
      };
    }
    this.httpservice.PluginPageDetials(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.p_apirespons = response.body;
          let respData = this.p_apirespons.RESPONSE_DATA;
          let respToken = this.p_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response_: any = Buffer.from(respData, 'base64');
            response_ = JSON.parse(response_);
            if (response_.original.status) {
              this.P_data = response_.original;
              this.navMenu = response_.original.hasMenu;
              this.navmenuloadCss = "height: 100%;";
            } else {
              this.P_data = response_.original;//somthing wrong
            }
            this.showNavComponent = true;
            this.showBarComponent = true;
          }
      }
    });
  }

}
